import Api from "../../config/api";
import {
  CREATE_EXPENSE,
  DELETE_EXPENSE_SOFT,
  SEARCH_EXPENSE,
  SEARCH_EXPENSE_BY_ID,
  UPDATE_EXPENSE,
} from "../../utils/constants";
import { showToast } from "../toast/ShowToast";

export const getExpense = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_EXPENSE, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getExpenseById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_EXPENSE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createExpense = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_EXPENSE, body);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      let msg = error?.response?.data?.message.split(":");
      if (msg[2] === " number_1_company_1 dup key") {
        showToast(`Expense number already taken`, "error");
        hideLoader();
        return error;
      } else {
        showToast(`${error?.response?.data?.message}`, "error");
        hideLoader();
      }
    }
  }
};

export const updateExpense = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_EXPENSE}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const restoreExpense = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).delete(`${DELETE_EXPENSE_SOFT}`, {
      data: body,
    });
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
